import type { CategoryKey } from '@/domains/assessment/types';

export interface CategoryBarProps {
  categoryKey: CategoryKey;
  name: string;
  score: number; // 0 a 100
  isPrimaryPriority?: boolean;
  isSecondaryPriority?: boolean;
  hasRetentionRisk?: boolean;
  className?: string;
}

export function CategoryBar({
  name,
  score,
  isPrimaryPriority = false,
  isSecondaryPriority = false,
  hasRetentionRisk = false,
  className = '',
}: CategoryBarProps) {
  const clampedScore = Math.max(0, Math.min(100, Math.round(score)));

  // Cores dinâmicas para a barra
  const getBarColor = (val: number): string => {
    if (val < 40) return 'bg-feedback-danger';
    if (val < 65) return 'bg-feedback-warning';
    return 'bg-brand-orange';
  };

  return (
    <div
      className={`rounded-xl border p-4 transition-all ${
        isPrimaryPriority
          ? 'border-brand-orange bg-brand-orange/10 shadow-md ring-1 ring-brand-orange'
          : hasRetentionRisk
            ? 'border-feedback-danger/60 bg-feedback-danger/5'
            : 'border-white/10 bg-navy-light/40'
      } ${className}`}
    >
      <div className="mb-2 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <span className="text-sm font-bold text-white">{name}</span>
          {isPrimaryPriority && (
            <span className="rounded-md bg-brand-orange px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white">
              Prioridade 01
            </span>
          )}
          {isSecondaryPriority && (
            <span className="rounded-md bg-brand-orangeSecondary/80 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white">
              Prioridade 02
            </span>
          )}
          {hasRetentionRisk && (
            <span className="rounded-md bg-feedback-danger px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white">
              Risco Retenção
            </span>
          )}
        </div>
        <span className="text-sm font-extrabold text-brand-orange">{clampedScore}%</span>
      </div>

      <div
        role="progressbar"
        aria-valuenow={clampedScore}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`Nota da área ${name}: ${clampedScore}%`}
        className="h-2 w-full overflow-hidden rounded-full bg-white/10"
      >
        <div
          className={`h-full rounded-full ${getBarColor(clampedScore)} transition-all duration-700 ease-out motion-reduce:transition-none`}
          style={{ width: `${clampedScore}%` }}
        />
      </div>
    </div>
  );
}
